import React from 'react'
import Layout from '../../../../../../component/layout/Layout'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const ManualMicormeter = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 1500,        // ✅ slower transition (2 seconds)
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500 // ✅ stays 3 seconds before next slide (optional)
    };

    const images = [
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2Finstruments%2Fpulp%26paper%2Fpaperinstrument%2Fimg%2F1771322773524_Pneumatic_Freeness_Tester.png?alt=media&token=252daa18-9491-4330-b8be-7f34351e7cb1',
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2Finstruments%2Fpulp%26paper%2Fpaperinstrument%2Fimg%2F1771322773524_Pneumatic_Freeness_Tester.png?alt=media&token=252daa18-9491-4330-b8be-7f34351e7cb1'
    ];


  return (
    <Layout>
       <div className="bread">
                <ul className="collapsed">
                    <li><a href="/">Home</a></li>
                    <li><a href="/paperTesting">Paper Testing</a></li>
                </ul>
            </div>
            <div className="container">
                <div className="section-title text-center" style={{ marginBottom: '2rem' }}>
                    <h1>Pneumatic Freeness Tester Schooper-Riegler</h1>
                </div>
            </div>
            <section id="portfolio-details" className="portfolio-details" style={{ backgroundColor: 'white', marginBottom: '12rem' }}>
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-lg-8">
                            <div className="portfolio-details-slider swiper">
                                <Slider {...settings}>
                                    {images.map((src, index) => (
                                        <div className="swiper-slide" key={index}>
                                            <div className="img" style={{ alignItems: 'center' }}>
                                                <img src={src} alt="" className="responsive" />
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                                <div className="swiper-pagination"></div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="portfolio-info" style={{ backgroundColor: 'white' }}>
                                <h3 className='pageheading'>Pneumatic Freeness Tester Schooper-Riegler</h3>
                                <p className='descriptionHead' style={{ textAlign: 'justify' }}>
                                 To determine the refining degree and draining velocity of paper fibres – Schopper-Riegler method. This test quickly provides an idea of the degree of refining that is related to the drainage rate of a dilute pulp suspension. Drainage speed has been shown to be related to surface conditions and fiber dilation, and is a useful indicator of the amount of mechanical treatment (refining) to which cellulose pulp is subjected. This method is applicable to all types of pastes in aqueous suspension, except for those extremely short fiber pulps.
                                 <br /><br />
                                    <a
                                        href="mailto:inst@rmc.in?subject=Inquiry about Pneumatic Freeness Tester Schooper-Riegler"
                                        style={{ color: '#0d6efd', fontWeight: '600', textDecoration: 'underline' }}
                                    >
                                        More Info
                                    </a>
                                </p>
                            </div>
                            <div className="portfolio-description"></div>
                        </div>
                    </div>
                </div>
            </section>
    </Layout>
  )
}

export default ManualMicormeter
